import {
  REQUEST as req, RESPONSE as res, FAILURE as fail, CLEAR as clr,
} from '../../actions/foundation/byomRegister';

const initialState = {
  response: null,   // { blueprint_id, model_id?, training_id?, compatibility? }
  isLoading: false,
  error: null,      // { message, code, details? } - details carries
                    // issues/expected for byom_incompatible_segment
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case req:  return { ...initialState, isLoading: true };
    case res:  return { ...state, isLoading: false, response: action.payload };
    case fail: return { ...state, isLoading: false, error: action.payload };
    case clr:  return initialState;
    default:   return state;
  }
};
